module.exports = __webpack_public_path__ + "static/media/CompanyIntroduceImage01.b4b753e6.png";